<template>
  <div class="main-wrap">
    <div id="main-content">
      <div class="wrapper">
        <jm-crumbs/>
        <div class="table-agile-info">
          <div class="common-new-title mode2">
            <span>文案赴日进度统计</span>
          </div>
          <el-row class="searchList" :gutter="10">
            <el-col :span="8">
              入学时间：
              <el-select
                class="jm-input135"
                v-model="searchData.year">
                <el-option
                  v-for="(option) in constDict.year"
                  :key="option"
                  :label="option"
                  :value="option"/>
              </el-select>
            </el-col>
            <el-col :span="8">
              是否赴日：
              <jm-dict-select
                v-model="searchData.is_gone_japan"
                empty-value=""
                empty-label="请选择"
                type="jiemo"
                value-type="string"
                dict-type="jp_process_gone_japan"/>
            </el-col>
            <el-col :span="8">
              是否缴纳学费：
              <jm-dict-select
                v-model="searchData.is_pay_study"
                empty-value=""
                empty-label="请选择"
                type="jiemo"
                value-type="string"
                dict-type="jp_process_pay_study"/>
            </el-col>
            <el-col :span="8">
              赴日意向：
              <jm-dict-select
                v-model="searchData.purpose_level"
                empty-value=""
                empty-label="请选择"
                type="jiemo"
                value-type="string"
                dict-type="jp_process_purpose_level"/>
            </el-col>
            <el-col :span="8">
              签证递签状态：
              <jm-dict-select
                v-model="searchData.sign_status"
                empty-value=""
                empty-label="请选择"
                type="jiemo"
                value-type="string"
                dict-type="jp_process_sign_status"/>
            </el-col>
          </el-row>

          <jm-tableList
            v-if="searchData"
            url="/index/b_i_j_p_writer/fetchTeacher"
            :refresh="refresh"
            :search-data="searchData"
            :no-pagination="true"/>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
import jmTableList from '@/components/data/tableList';
import common from '@/pages/bi/common';
import { jmChannel } from '@/components/tool';
import { jmDictSelect } from '@/components/tool/index.js';

let constDict = {
  year: ['全部']
};

export default {
  mixins: [common],
  data() {
    return {
      constDict,
      chartsData: {
        refresh: 1
      },
      chartsSort: {
        options: [],
        value: '资源数'
      },
      refresh: false,
      searchData: {
        is_gone_japan: '',
        is_pay_study: '',
        purpose_level: '',
        sign_status: '',
        year: (new Date()).getFullYear(),
      }
    };
  },
  components: {
    jmChannel,
    jmTableList,
    jmDictSelect
  },
  created() {
    this.$http
      ._get({
        url: '/index/b_i_j_p_writer/searchDict'
      })
      .then(({ data }) => {
        this.constDict = Object.assign({}, this.constDict, data);
        console.log('constDict', this.constDict);
        this.$store.commit('updateRefresh', true);
      });
  },
  methods: {
    init() {
      this.$store.commit('updateRefresh', true);
    }
  },
  watch: {
    searchData: {
      handler: function () {
        this.$nextTick(this.init);
      },
      deep: true
    }
  }
};
</script>

<style scoped>
.searchList *{
  padding: 5px;
}
</style>
